import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import {
	faHeartCrack as fasHeartCrack,
	faExclamation as fasExclamation,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	error: string;
}

export class ResultError extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { error } = this.props;

		return (
			<>
				<Card.Header className="text-center mt-2">
					<FontAwesomeIcon icon={fasHeartCrack} className="fa-5x text-gold" />
					<div className="h4 mb-0 text-white font-weight-bold">
						Sajnos nem vagy jogosult
						<br />
						támogatás igénybevételére.
					</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="d-flex py-2">
						<div className="text-center my-auto ml-auto pr-2">
							<FontAwesomeIcon icon={fasExclamation} size="3x" />
						</div>
						<div className="pl-2 border-left py-2">{error}</div>
					</div>
				</Card.Body>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success result-page"]).join(" ");
	}

	protected getComponentName(): string {
		return "ResultError";
	}
}
